import {CommandClause, CPCLCommand} from "@psdk/frame-father";
import {BasicCPCLArg} from "./basic";
import {CLocation} from "../types";
import {CGap} from "./gap";
import {CForm} from "./form";

export class CPageMode extends BasicCPCLArg<CPageMode> {
  private location: CLocation;

  constructor(options?: {

    location?: CLocation
  }) {
    super();
    this.location = options?.location ?? CLocation.NO_LOCATION;
  }

  clause(): CommandClause {
    if (this.location > 0)
      super.prepend(new CGap()).prepend(new CForm());
    return CPCLCommand.with(this.header())
      .clause();
  }

  header(): string {
    return '';
  }
}



